import baseAPIBuilder from "@/js/api/builder/api-builder";
import { manageAPIError } from "@/js/api/builder/api-error";
import { webServerConnection } from "@/js/network/axios";
import { z } from "zod";

const listPrincipalsReplySchema = z.array(
	z.object({
		id: z.uuid(),
		name: z.string()
	})
);
export type ListPrincipalsReply = z.infer<typeof listPrincipalsReplySchema>;

const meta = {
	basePath: "/",
	mapping: {
		collection_id: "collectionId",
		collection_owner: "collectionOwner",
		display_name: "displayName",
		personal_collections: "personalCollections",
		global_collections: "globalCollections",
		collection_ids: "collectionIds",
		resource_id: "resourceId"
	},
	dateFields: [],
	connection: webServerConnection
};

const builder = new baseAPIBuilder(meta as any);
const connection = builder.connection!.axios;

const mapOutput = (data: unknown): unknown => builder.output(data);

const validateOutput = <TSchema extends z.ZodTypeAny>(
	schema: TSchema,
	data: unknown
): z.infer<TSchema> => schema.parse(mapOutput(data));

export const listPrincipals = (): Promise<ListPrincipalsReply> => {
	return connection
		.get("user/principals/all")
		.then((response: { data: unknown }) =>
			validateOutput(listPrincipalsReplySchema, response.data)
		)
		.catch(manageAPIError);
};
